export const EVENT_TYPE_OPTIONS = [
  ["wedding", "Γάμος"],
  ["baptism", "Βάπτιση"],
  ["wedding_and_baptism", "Γάμος - Βάπτιση"],
  ["corporate", "Εταιρικό"],
  ["outdoor", "Outdoor"],
] as const;

export type InquiryEventType = (typeof EVENT_TYPE_OPTIONS)[number][0];

/** «Γεγονός» chips. Same codes and labels as EVENT_TYPE_OPTIONS, plus free-text Άλλο. */
export const OCCASION_CHOICES = [
  ...EVENT_TYPE_OPTIONS,
  ["other", "Άλλο"],
] as const;

const EXTRA_TYPE_LABELS: Record<string, string> = {
  other: "Αλλο",
  unknown: "Χωρίς τύπο",
};

export const EVENT_TYPE_LABELS: Record<string, string> = {
  ...Object.fromEntries(EVENT_TYPE_OPTIONS),
  ...EXTRA_TYPE_LABELS,
};

/** Older screens stored these phrases for wedding_and_baptism. Read them as the current label; do not rewrite rows. */
const LEGACY_EVENT_LABELS: Record<string, string> = {
  "γαμος & βαπτιση": "wedding_and_baptism",
  "γαμος και βαπτιση": "wedding_and_baptism",
  "γαμοβαφτιση": "wedding_and_baptism",
};

export function isInquiryEventType(value: string | null): value is InquiryEventType {
  return EVENT_TYPE_OPTIONS.some(([key]) => key === value);
}

/** Codes stay codes. Known labels, including «Γάμος & Βάπτιση», become the shared event-type code. */
export function canonicalEventType(value: string | null | undefined): string | null {
  const text = (value ?? "").trim();
  if (!text) return null;
  if ((OCCASION_CHOICES as readonly (readonly [string, string])[]).some(([key]) => key === text) || text === "unknown") return text;
  const fromList = EVENT_TYPE_OPTIONS.find(([, label]) => label === text);
  if (fromList) return fromList[0];
  const folded = text.normalize("NFD").replace(/\p{M}/gu, "").toLowerCase().replace(/\s+/g, " ");
  if (folded === "αλλο") return "other";
  return LEGACY_EVENT_LABELS[folded] ?? null;
}

export function eventTypeLabel(value: string | null | undefined): string {
  if (!value) return "";
  const choice = OCCASION_CHOICES.find(([key]) => key === value);
  if (choice) return choice[1];
  if (EVENT_TYPE_LABELS[value]) return EVENT_TYPE_LABELS[value];
  const code = canonicalEventType(value);
  if (!code || code === value) return "";
  return eventTypeLabel(code);
}
